/**
 * @file ヘッダーの背景クラスつけ外し
 *
 */
'use strict';
import { throttle } from "lodash";

/**
 * @classname ShowHeaderBGView
 * @classdesc ヘッダーの背景クラスつけ外し
 */
export default class ShowHeaderBGView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ShowHeaderBGView.constructor');
		this._$e = $e;
		let $dependencyObj = $('.secAbout');
		document.addEventListener('scroll', throttle(() => {
			$(window).scrollTop() < $dependencyObj.offset().top - 200 ? this._$e.removeClass('is-scrolled') : this._$e.addClass('is-scrolled')
		}, 200), { passive: true });
	};
}
